import React from 'react'

import { Box, Card, CardContent, CardHeader } from '@mui/material'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import type { RootState } from 'reducers'

import { addPaused, addRunning } from 'actions/campaign-targets-actions'
import { Table } from 'components/table'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { useCampaignCompanies } from 'hooks/useCampaignCompanies'
import { usePaginatedTableMeta } from 'hooks/usePaginatedTableMeta'

import CampaignTargetActionButton from '../targets/CampaignTargetActionButton'

const CampaignCompanies = () => {
  const { id } = useParams()
  const { meta, setPage, setRowsPerPage } = usePaginatedTableMeta({ rowsPerPage: 5 })
  const { data, isLoading, error } = useCampaignCompanies(id, meta)
  const dispatch = useAppDispatch()
  // The running/paused selection stays in redux (campaign-targets), shared with the targets tab.
  const targetsUpdates = useSelector((s: RootState) => s.campaignTargets.meta.get('updates'))

  const renderActionButton = (rowData: any) => (
    <CampaignTargetActionButton
      addPaused={(...args: any[]) => dispatch(addPaused(...args))}
      addRunning={(...args: any[]) => dispatch(addRunning(...args))}
      data={rowData}
      updates={targetsUpdates}
    />
  )

  const config = [
    { title: 'Name', field: 'name' },
    { title: 'UUID', field: 'companyUuid' },
    { title: 'Views', field: 'views' },
    { title: 'Clicks', field: 'clicks' },
    { title: 'Share', render: (rowData: any) => `${rowData.share}%`, headerStyle: { width: '30px' } },
    { title: 'Status', field: 'status', headerStyle: { width: '50px' } },
    { title: 'Action', headerStyle: { width: '30px' }, render: renderActionButton },
  ]

  return (
    <Card>
      <CardHeader title="Companies" />
      <CardContent>
        <Box sx={{ width: '100%' }}>
          <Table
            config={config}
            count={data?.count}
            data={data?.items}
            error={error ? 'Error occurred when loading campaign companies data' : undefined}
            loading={isLoading}
            onChangePage={setPage}
            onChangeRowsPerPage={setRowsPerPage}
            page={meta.page}
            rowsPerPage={meta.rowsPerPage}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default CampaignCompanies
